export const OFFLINE = 0
export const ONLINE = 1
